import { createReducer } from '@reduxjs/toolkit';

import { GetQrData } from './backupGenerateQrThunk';


const handleAsyncActions = (builder, action, stateKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[stateKey] = true; // Set loading for specific API
      state[stateKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request is fulfilled
      state[stateKey] = action.payload; // Set the fulfilled data
      state.error[errorKey] = null; // Reset error
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request fails
      state.error[errorKey] = action.payload; // Set specific error message for the API call
    });
};

const initialState = {
    GetQrDetails: null,
  // Dynamic loading and error states for each API
  loading: {
    GetQrDetails: false,
  },

  error: {
    GetQrDetailsError: null,
  },
};

export const BackupQRReducer = createReducer(initialState, (builder) => {
  // Use the utility function to handle async actions
  handleAsyncActions(builder, GetQrData, "GetQrDetails", "GetQrDetailsError");
  


});

export default BackupQRReducer;




